import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const SchedulingSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Set up Scheduling now' onButtonClick={() => navigate('/workspace/setup/scheduling')} />
}
